import { t } from 'i18next';
import React from 'react';
import withStyles from 'react-jss';
import { connect } from 'react-redux';
import { getTenantState } from '../../../store/selectors';

const styles = {
  barColor: (props) => ({
    backgroundColor: props.tenant.secondary,
  }),
  nextColorActive: (props) => ({
    backgroundColor: props.tenant.primary,
    color: 'white',
    border: 'none',

    '&:hover': {
      backgroundColor: 'white',
      border: `2px solid ${props.tenant.primary}`,
      color: props.tenant.primary,
      borderStyle: 'solid',
    },
  }),
  nextColorInactive: (props) => ({
    backgroundColor: '#e5e5e5',
    color: 'black',
    border: 'none',
  }),
};

function CareerPathsBar(props) {
  const activeOrInactiveClass = () =>
    props.isActive
      ? props.classes.nextColorActive
      : props.classes.nextColorInactive;

  return (
    <div className={['career-paths-bar', props.classes.barColor].join(' ')}>
      {t('{{number}} Career Paths Built', {
        number: props.pathsText,
        interpolation: { escapeValue: false },
      })}
      <button
        type="button"
        aria-label={
          !props.isActive
            ? t(
                `Next button disabled. Please pair degrees with each of your top chosen careers in order to move forward`
              )
            : t(
                `Next button enabled. Click to move forward to the dashboard. All careers have been paired with degrees.`
              )
        }
        className={[
          activeOrInactiveClass(),
          'career-paths-bar__next-button',
        ].join(' ')}
        disabled={!props.isActive}
        onClick={props.onNextClick}
      >
        {t('Next')}
      </button>
    </div>
  );
}

const mapStateToProps = (state) => ({
  tenant: getTenantState(state),
});

export default withStyles(styles)(connect(mapStateToProps, {})(CareerPathsBar));
